import { ToastOptions } from 'react-toastify';

export const toastifyConfig: ToastOptions = {
	position: 'top-right',
	autoClose: 3000,
	hideProgressBar: true,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true,
	progress: undefined,
};
